import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "_flex _ai-c _gap-1" }
const _hoisted_3 = {
  class: "_flex _gap-1 _tc--accent",
  "data-qa": `gift-card-group-collapse-expand`
}
const _hoisted_4 = { class: "_mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_thumbnail = _resolveComponent("backer-center-thumbnail")
  const _component_base_text = _resolveComponent("base-text")
  const _component_balloon_actions = _resolveComponent("balloon-actions")
  const _component_backer_center_header = _resolveComponent("backer-center-header")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_backer_center_gift_card_row = _resolveComponent("backer-center-gift-card-row")
  const _component_base_collapsible = _resolveComponent("base-collapsible")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", {
    class: "_pos-r",
    "data-qa": `gift-card-group-row-${$options.groupKey}`
  }, [
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createVNode(_component_backer_center_header, null, {
          prefix: _withCtx(() => [
            _createVNode(_component_backer_center_thumbnail, {
              "image-url": $props.group.imageUrl,
              name: $props.group.name,
              url: $options.groupUrl
            }, null, 8 /* PROPS */, ["image-url", "name", "url"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_base_text, {
              as: "a",
              level: "b1",
              class: "_toe _my-a",
              title: $options.groupName,
              href: $options.groupUrl
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.groupName), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "href"])
          ]),
          suffix: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!$options.isMobile)
                ? (_openBlock(), _createBlock(_component_base_text, {
                    key: 0,
                    level: "b1",
                    "data-qa": "gift-card-group-balance"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.balanceLabel), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              ($options.groupUrl)
                ? (_openBlock(), _createBlock(_component_balloon_actions, {
                    key: 1,
                    actions: $options.actions,
                    theme: "lightOutline",
                    mode: $options.balloonActionsModes.grouped,
                    "data-qa": "gift-card-group-actions"
                  }, null, 8 /* PROPS */, ["actions", "mode"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }),
        ($options.isMobile)
          ? (_openBlock(), _createBlock(_component_base_text, {
              key: 0,
              level: "b1",
              as: "div",
              class: "_mt-3 _mb-4",
              "data-qa": "gift-card-group-balance"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.balanceLabel), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_base_collapsible, {
          rounded: false,
          class: "_tc--accent _mt-3"
        }, {
          trigger: _withCtx(({ isExpanded }) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_base_icon, {
                name: isExpanded ? 'chevron-up' : 'chevron-down'
              }, null, 8 /* PROPS */, ["name"]),
              _createTextVNode(" " + _toDisplayString($options.toggleLabel(isExpanded)), 1 /* TEXT */)
            ])
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.group.giftCards, (giftCard, giftCardIndex) => {
                return (_openBlock(), _createBlock(_component_backer_center_gift_card_row, {
                  key: giftCard.giftCardID,
                  "gift-card": giftCard,
                  "show-divider": giftCardIndex > 0,
                  onViewHistory: _cache[0] || (_cache[0] = $event => (_ctx.$emit('view-history', $event)))
                }, null, 8 /* PROPS */, ["gift-card", "show-divider"]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ], 8 /* PROPS */, _hoisted_1))
}